export default [
		{
	  path: "/sakip",
	  name: "sakip",
	  component: () => import(`@/modules/esakip/index.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/renstra",
	  name: "Renstra",
	  component: () => import(`@/modules/prolap/renstra.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/capaian",
	  name: "capaian",
	  component: () => import(`@/modules/capaian.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/stat_akip",
	  name: "Statistik Akip",
	  component: () => import(`@/modules/stat_akip.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/stat_perjanjian",
	  name: "Perjanjian Bupati Akip",
	  component: () => import(`@/modules/stat_perjanjian.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/stat_pk_bupati",
	  name: "Perjanjian Bupati Akip",
	  component: () => import(`@/modules/stat_pk_bupati.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/stat_capaian",
	  name: "Capaian Kinerja Kabupaten",
	  component: () => import(`@/modules/stat_capaian.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/stat_efisiensi",
	  name: "Capaian Efisiensi Anggaran Kabupaten",
	  component: () => import(`@/modules/stat_efisiensi.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/raport",
	  name: "Raport",
	  component: () => import(`@/modules/raport.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/raport_sakip",
	  name: "raport_sakip",
	  component: () => import(`@/modules/raport_sakip.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/raport_iku",
	  name: "raport_iku",
	  component: () => import(`@/modules/raport_iku.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/rpjmd",
	  name: "rpjmd",
	  component: () => import(`@/modules/prolap/rpjmd.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true }
	},
	{
	  path: "/renja",
	  name: "Renstra",
	  component: () => import(`@/modules/prolap/renja.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/pohon_renstra",
	  name: "Pohon Renstra",
	  component: () => import(`@/modules/prolap/pohon_renstra.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/perjanjian",
	  name: "Perjanjian Kinerja",
	  component: () => import(`@/modules/prolap/perjanjian.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/prolap/pohon",
	  name: "Pohon",
	  component: () => import(`@/modules/prolap/pohon.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/realisasi",
	  name: "Realisasi",
	  component: () => import(`@/modules/prolap/realisasi.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/evaluasi",
	  name: "Evaluasi",
	  component: () => import(`@/modules/prolap/evaluasi.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/prolap/laporan",
	  name: "Laporan",
	  component: () => import(`@/modules/prolap/laporan.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/prolap/statistikAnggaran",
	  name: "statistikAnggaran",
	  component: () => import(`@/modules/prolap/statistikAnggaran.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/prolap/statistikProgram",
	  name: "statistikProgram",
	  component: () => import(`@/modules/prolap/statistikProgram.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/prolap/statistikKinerja",
	  name: "statistikKinerja",
	  component: () => import(`@/modules/prolap/statistikKinerja.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/prolap/statistikPeriodik",
	  name: "statistikKinerja",
	  component: () => import(`@/modules/prolap/statistikPeriodik.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/prolap/periode",
	  name: "periode",
	  component: () => import(`@/modules/prolap/periode.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/target",
	  name: "target",
	  component: () => import(`@/modules/prolap/target.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/persetujuan",
	  name: "persetujuan",
	  component: () => import(`@/modules/prolap/persetujuan.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	  path: "/pohon_kinerja",
	  name: "pohon_kinerja",
	  component: () => import(`@/modules/prolap/pohon_renstra.vue`),
	  meta: { layout: "dashboard"  , public : false  , auth: true }
	},
	{
	    path: "/laporanAkip",
	    name: "laporanAkip",
	    component: () => import(`@/modules/prolap/laporanAkip.vue`),
	    meta: { layout: "dashboard", public: false, auth: true }
	},
	{
	  path: "/rank/diagram",
	  name: "diagram_kinerja",
	  component: () => import(`@/modules/rangking/diagram.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/rank/raport",
	  name: "raport_kinerja",
	  component: () => import(`@/modules/rangking/raport.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/rank/rank",
	  name: "rangking_kinerja",
	  component: () => import(`@/modules/rangking/rangking.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},

	{
	  path: "/dash/main",
	  name: "dash_main",
	  component: () => import(`@/modules/dashboard/index.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/anggaran",
	  name: "anggaran",
	  component: () => import(`@/modules/anggaran.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
	{
	  path: "/verifikasi",
	  name: "verifikasi",
	  component: () => import(`@/modules/verifikasi.vue`),
	  meta: { layout: "dashboard" , public : false  , auth: true  }
	},
]  


// WEBPACK FOOTER //
// ./src/router/module.js